import { beginCell } from "@ton/core"

/** TonConnect transaction comment payload (Boc base64). */
export function makeCommentPayloadBase64(text: string): string {
  const cell = beginCell().storeUint(0, 32).storeStringTail(text).endCell()
  return cell.toBoc().toString("base64")
}
